import entries from "./timedata.json";

export const timelineEntries = [...entries].sort((a, b) =>
  Number(b.present) - Number(a.present) || b.date_from.localeCompare(a.date_from)
);

export const formatTimelineDate = (date) => new Intl.DateTimeFormat("en", {
  month: "short", year: "numeric", timeZone: "UTC",
}).format(new Date(date));
